module.exports = __webpack_public_path__ + "img/Xiaomi.231ad946.png";